(() => {
  if (window.__btkV2CountdownTimerLoaded) return;
  window.__btkV2CountdownTimerLoaded = true;

  const ROOT_SELECTOR = '[data-btk-v2-countdown]';
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function getNumberAttribute(root, attribute) {
    const value = Number(root.getAttribute(attribute));

    return Number.isFinite(value)
      ? Math.max(0, value)
      : 0;
  }

  function initCountdown(root) {
    if (!root) return;

    /*
      Destroy any previous instance first.

      This keeps the countdown clean when Shopify
      reloads the section in the Theme Editor.
    */
    if (
      typeof root.__btkV2CountdownDestroy === 'function'
    ) {
      root.__btkV2CountdownDestroy();
    }

    const countdownId =
      root.getAttribute('data-btk-v2-countdown-id') ||
      root.id ||
      'default';

    const startingDays = getNumberAttribute(
      root,
      'data-btk-v2-countdown-days'
    );

    const startingHours = getNumberAttribute(
      root,
      'data-btk-v2-countdown-hours'
    );

    const startingMinutes = getNumberAttribute(
      root,
      'data-btk-v2-countdown-minutes'
    );

    const startingSeconds = getNumberAttribute(
      root,
      'data-btk-v2-countdown-seconds'
    );

    const expiredBehavior =
      root.getAttribute(
        'data-btk-v2-expired-behavior'
      ) || 'zero';

    const daysElement = root.querySelector(
      '[data-btk-v2-countdown-days]'
    );

    const hoursElement = root.querySelector(
      '[data-btk-v2-countdown-hours]'
    );

    const minutesElement = root.querySelector(
      '[data-btk-v2-countdown-minutes]'
    );

    const secondsElement = root.querySelector(
      '[data-btk-v2-countdown-seconds]'
    );

    const timerElement = root.querySelector(
      '.btk-v2-countdown-timer__timer'
    );

    const expiredElement = root.querySelector(
      '[data-btk-v2-countdown-expired]'
    );

    if (
      !daysElement ||
      !hoursElement ||
      !minutesElement ||
      !secondsElement
    ) {
      return;
    }

    /*
      Convert the Theme Editor settings into
      one duration in milliseconds.
    */
    const duration =
      startingDays * DAY +
      startingHours * HOUR +
      startingMinutes * MINUTE +
      startingSeconds * SECOND;

    /*
      Include the configured duration in the storage
      key. If you change the timer settings, visitors
      automatically receive the new countdown.
    */
    const durationSignature = [
      startingDays,
      startingHours,
      startingMinutes,
      startingSeconds
    ].join('-');

    const storageKey =
      `btk-v2-countdown-${countdownId}-${durationSignature}`;

    let intervalId = null;
    let endTime = null;

    function setValues(
      days,
      hours,
      minutes,
      seconds
    ) {
      daysElement.textContent = pad(days);
      hoursElement.textContent = pad(hours);
      minutesElement.textContent = pad(minutes);
      secondsElement.textContent = pad(seconds);
    }

    function stopCountdown() {
      if (!intervalId) return;

      window.clearInterval(intervalId);
      intervalId = null;
    }

    root.__btkV2CountdownDestroy =
      stopCountdown;

    /*
      Restore the normal timer state whenever
      Shopify reloads the section.
    */
    root.hidden = false;

    if (timerElement) {
      timerElement.hidden = false;
    }

    if (expiredElement) {
      expiredElement.hidden = true;
    }

    if (duration <= 0) {
      setValues(0, 0, 0, 0);

      console.warn(
        'BTK V2 Countdown Timer: countdown duration must be greater than zero.'
      );

      return;
    }

    /*
      Try to use an existing timer end point.

      This prevents the countdown from restarting
      every time the customer refreshes the page.
    */
    try {
      const storedEndTime = Number(
        window.localStorage.getItem(storageKey)
      );

      if (
        Number.isFinite(storedEndTime) &&
        storedEndTime > 0
      ) {
        endTime = storedEndTime;
      }
    } catch (error) {
      /*
        localStorage may be unavailable in some
        restricted/private browser environments.
        The timer will still work normally.
      */
    }

    /*
      No timer exists for this visitor yet,
      so start a fresh duration.
    */
    if (!endTime) {
      endTime = Date.now() + duration;

      try {
        window.localStorage.setItem(
          storageKey,
          String(endTime)
        );
      } catch (error) {
        /*
          Ignore storage errors.
        */
      }
    }

    function handleExpired() {
      if (expiredBehavior === 'renew') {
        endTime =
          Date.now() + duration;

        try {
          window.localStorage.setItem(
            storageKey,
            String(endTime)
          );
        } catch (error) {
          /*
            Ignore storage errors.
          */
        }

        setValues(
          startingDays,
          startingHours,
          startingMinutes,
          startingSeconds
        );

        return;
      }

      stopCountdown();

      setValues(0, 0, 0, 0);

      if (expiredBehavior === 'hide') {
        root.hidden = true;
        return;
      }

      if (expiredBehavior === 'message') {
        if (timerElement) {
          timerElement.hidden = true;
        }

        if (expiredElement) {
          expiredElement.hidden = false;
        }
      }
    }

    function updateCountdown() {
      const difference =
        endTime - Date.now();

      if (difference <= 0) {
        handleExpired();
        return;
      }

      const totalSeconds = Math.max(
        0,
        Math.floor(difference / SECOND)
      );

      const days = Math.floor(
        totalSeconds / 86400
      );

      const hours = Math.floor(
        (totalSeconds % 86400) / 3600
      );

      const minutes = Math.floor(
        (totalSeconds % 3600) / 60
      );

      const seconds =
        totalSeconds % 60;

      setValues(
        days,
        hours,
        minutes,
        seconds
      );
    }

    /*
      Render immediately.
    */
    updateCountdown();

    /*
      Only start the interval if the timer
      has not already expired.
    */
    if (endTime > Date.now()) {
      intervalId = window.setInterval(
        updateCountdown,
        1000
      );
    }
  }

  function initAllCountdowns(
    scope = document
  ) {
    if (scope.matches?.(ROOT_SELECTOR)) {
      initCountdown(scope);
      return;
    }

    scope
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllCountdowns();
      }
    );
  } else {
    initAllCountdowns();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllCountdowns(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const root =
        event.target.matches?.(ROOT_SELECTOR)
          ? event.target
          : event.target.querySelector(
              ROOT_SELECTOR
            );

      if (
        root &&
        typeof root.__btkV2CountdownDestroy ===
          'function'
      ) {
        root.__btkV2CountdownDestroy();
      }
    }
  );
})();